import { render, staticRenderFns } from "./spot_space_order_detail.vue?vue&type=template&id=29c9b8ce&scoped=true&"
import script from "./spot_space_order_detail.vue?vue&type=script&lang=js&"
export * from "./spot_space_order_detail.vue?vue&type=script&lang=js&"
import style0 from "./spot_space_order_detail.vue?vue&type=style&index=0&id=29c9b8ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c9b8ce",
  null
  
)

export default component.exports